import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { computed, defineComponent, reactive, ref } from "vue";
import Tabs from "@/components/Tabs/index.vue";
import Head from "@/components/Head/index.vue";
import Pagination from "@/components/Pagination/index.vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { useRouter } from "vue-router";
export default defineComponent({
  name: "Learning",
  components: {
    Head: Head,
    Tabs: Tabs,
    Pagination: Pagination
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var title = ["我的收藏", "下载记录"];
    var loading = ref(true);
    var router = useRouter();
    var show = ref(true);
    var data = reactive({
      list: [{
        content: ''
      }],
      totalNum: 0 //总数

    });
    var downData = reactive({
      list: [{}],
      totalNum: 0
    }); //收藏列表

    function collectList(_x) {
      return _collectList.apply(this, arguments);
    }

    function _collectList() {
      _collectList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(val) {
        var lis;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["collectList"](val);

              case 2:
                lis = _context.sent;

                if (lis.code == 0) {
                  if (lis.data.length == 0) {
                    show.value = true;
                  } else {
                    show.value = false;
                  }

                  data.list = lis.data;
                  data.list.forEach(function (element) {
                    if (element.content && element.content != '') {
                      element.content = element.content.replace(/<(img).*?>/g, "【图片】");
                    }
                  });
                  data.totalNum = lis.total;
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _collectList.apply(this, arguments);
    }

    collectList({
      pageIndex: 1,
      pageSize: 10,
      type: 1
    });
    var pag = ref(0);

    function changPage(val) {
      if (pag.value == 0) {
        collectList({
          pageIndex: val,
          pageSize: 10,
          type: 1
        });
      } else {
        downloadRecordt({
          pageIndex: val,
          pageSize: 10,
          type: 2
        });
      }
    }

    function todetail(val) {
      if (val.category == 2) {
        router.push({
          name: "StudyDetail",
          query: {
            newsId: val.contentId
          }
        });
      } else {
        router.push({
          name: 'learningDetail',
          query: {
            id: val.contentId,
            category: val.category
          }
        });
      }
    }

    function downloadRecordt(_x2) {
      return _downloadRecordt.apply(this, arguments);
    }

    function _downloadRecordt() {
      _downloadRecordt = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(val) {
        var lis;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["downloadRecordt"](val);

              case 2:
                lis = _context2.sent;

                if (lis.code == 0) {
                  downData.list = lis.data;
                  data.totalNum = lis.total;
                  loading.value = false;
                }

                console.log(11111);
                console.log(lis);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _downloadRecordt.apply(this, arguments);
    }

    function changeOther(val) {
      pag.value = val;
      console.log(val);

      if (val == 1) {
        downloadRecordt({
          pageIndex: 1,
          pageSize: 10,
          type: 2
        });
      } else {
        collectList({
          pageIndex: 1,
          pageSize: 10,
          type: 1
        });
      }
    }

    var deleteTag = computed(function () {
      return function (str) {
        var tagStr = str;
        tagStr = tagStr.replace(/<img[^>]*>/g, "[图片]");
        var regx = /<[^>]*>|<\/[^>]*>/gm;
        var result = tagStr.replace(regx, "");
        return result;
      };
    });
    return {
      title: title,
      collectList: collectList,
      data: data,
      changPage: changPage,
      todetail: todetail,
      downData: downData,
      downloadRecordt: downloadRecordt,
      changeOther: changeOther,
      pag: pag,
      show: show,
      loading: loading,
      deleteTag: deleteTag
    };
  }
});